// app/providers/SWRProvider.tsx
'use client';

import { SWRConfig } from 'swr';
import { fetcher } from '@/utils/fetcher'; // Ensure this fetcher is exported from your utils

export function SWRProvider({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        dedupingInterval: 60000, // Adjust as needed
      }}
    >
      {children}
    </SWRConfig>
  );
}
